<template>
  <div>
    <div fluid class="d-flex px-0">
      <b-card id="card-principal" class="m-0 flex-grow-1">
        <template #header>
          <div class="d-flex">
            <div class="flex-grow-1">
              <i class="fas fa-edit"></i>
              <strong>{{$lang.PCI.PDR.PrincipalTitle}}</strong>
            </div>
            <div class="card-actions" v-if="!isArchived">
              <b-link href="#" v-b-tooltip.hover :title="'Limpar Filtros'" @click="clearLayoutAndFilters">
                <i class="fas fa-filter" style="text-decoration: line-through"></i>
              </b-link>
              <b-link href="#" v-if="selectedPdrObraID" v-b-tooltip.hover :title="'Avaliação de Pedidos'" @click="onEvaluationOrder">
                <i class="far fa-file-alt" style="font-size:15px;"></i>
              </b-link>
              <b-link href="#" @click="onLoad">
                <i class="fas fa-sync-alt text-third" style="font-size:15px;"></i>
              </b-link>
            </div>
          </div>
        </template>
        <b-row class="px-2">
          <div style="margin-bottom:.5em;font-weight:bold;cursor:pointer" v-if="!isArchived" @click="hideStatusDone()">
            <i v-if="hideStatusDoneEnabled" class="fa fa-check-circle" style="font-size:15px;color:green"></i>
            <i v-if="!hideStatusDoneEnabled" class="fa fa-circle" style="font-size:15px;color:lightgrey;"></i>
            <span> {{$lang.Common.HidePdrDoneButton}} </span>
          </div>
          <ag-grid-vue style="width: 100%; height: calc(100vh - 695px)" id="obras-grid"
                  class="ag-theme-alpine"
                  :rowMultiSelectWithClick="false"
                  rowSelection="single"
                  :getLocaleText="localeTextFunc"
                  :gridOptions="workDataGridOptions"
                  :columnTypes="columnTypes"
                  :columnDefs="workColumnDefs"
                  :getContextMenuItems="getContextMenuItems"
                  :defaultColDef="defaultColumnDef"
                  :rowData="workRowData"
                  :getRowId="params => params.data.id"
                  :suppressColumnVirtualisation=true
                  :excelStyles="excelStyles"
                  :sideBar="sideBar"
                  @rowSelected="selectPdr"
                  @gridReady="onGridPdrReady"
                  @filterChanged="onFilterPdrChanged"
                  @toolPanelVisibleChanged="onToolPanelVisibleChanged"
                  >
          </ag-grid-vue>
        </b-row>
        <b-row style="display: flow-root;">
          <b-col cols="1">
            <span style="font-size: small;font-weight: bold;">Total: </span>
            {{ totalWorkRows }}
          </b-col>
          <b-button variant="primary" :disabled="!workMemberID"
                    v-bind:title="workMemberName"
                    style="float:right;top:3.4em;right:2em;position:relative;"
                    @click="generatePDF"><i class="fa fa-print"></i></b-button>
        </b-row>
        <b-row>
          <b-tabs id="tabEquipe" v-model="tabIndex" pills card>
            <b-tab :title="$lang.PCI.PDR.TabTitles.Team" @click="resetPdfButton()">
              <ag-grid-vue style="width: 100%; height: 250px;" id="equipe-grid"
                      class="ag-theme-alpine"
                      :rowMultiSelectWithClick="false"
                      rowSelection="single"
                      :getLocaleText="localeTextFunc"
                      :gridOptions="teamDataGridOptions"
                      :columnTypes="columnTypes"
                      :columnDefs="teamColumnDefs"
                      :defaultColDef="defaultColumnDef"
                      :rowData="teamRowData"
                      :suppressColumnVirtualisation=true
                      @gridReady="onGridMembersReady"
                      >
              </ag-grid-vue>
            </b-tab>
            <b-tab v-for="item in teamForms" :key="item.id" :title="item.nome" @click="onTabClicked(item)">
              <ag-grid-vue v-if="gridItemsForm.length" style="width: 100%; height: 250px;" id="equipe-grid"
                           class="ag-theme-alpine"
                           :rowMultiSelectWithClick="false"
                           rowSelection="single"
                           :getLocaleText="localeTextFunc"
                           :columnTypes="columnTypes"
                           :columnDefs="selectItemsForm(item.id).grid.Headers"
                           :defaultColDef="defaultColumnDef"
                           :rowData="selectItemsForm(item.id).grid.Data"
                           :suppressColumnVirtualisation=true
                           :tooltipShowDelay="200"
                           :groupHeaderHeight="20"
                           :headerHeight="20"
                           :rowHeight="30"
                           @cellDoubleClicked="evaluateMember"
                           @gridReady="onGridFormReady($event, item.id)"
                           @rowSelected="memberSelected"
              >
              </ag-grid-vue>
            </b-tab>
            <b-tab :title="$lang.PCI.PDR.TabTitles.Evaluation"
                   @click="() => {
                      finalEvaluationDataGridOptions.api.sizeColumnsToFit()
                      resetPdfButton()
                    }">
              <ag-grid-vue style="width: 100%; height: 250px;" id="final-evaluation-grid"
                      class="ag-theme-alpine"
                      :rowMultiSelectWithClick="false"
                      rowSelection="single"
                      :getLocaleText="localeTextFunc"
                      :gridOptions="finalEvaluationDataGridOptions"
                      :columnTypes="columnTypes"
                      :columnDefs="finalEvaluationColumnDefs"
                      :defaultColDef="defaultColumnDef"
                      :rowData="finalEvaluationRowData"
                      :suppressColumnVirtualisation=true
                      @cellValueChanged="onEditFinalEvaluation"
                      >
              </ag-grid-vue>
            </b-tab>
          </b-tabs>
        </b-row>
      </b-card>
    </div>

    <evaluation-order ref="evaluationOrder" />

    <b-modal
      ref="stoppageModal"
      size="lg"
      v-model="showStoppageHistory"
      v-if="showStoppageHistory"
      :hide-footer="true"
      centered
    >
      <template #modal-header>
        <div class="d-flex align-items-center col-12">
          <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
          <span class="modalTitle ml-auto">
            {{$lang.PCI.Stoppage.Title}}
          </span>
          <button class="close" @click="$refs.stoppageModal.hide()">x</button>
        </div>
      </template>
      <Tables ref="tableGrid"
              :columns="[
                $lang.PCI.PDR.StoppageDatatable.Stoppage,
                $lang.PCI.PDR.StoppageDatatable.Return,
                $lang.PCI.PDR.StoppageDatatable.Motive
              ]"
              :showSearch="false"
              :showPrint="false"
              :showDownload="false"
              :showFullscreen="false"
              :showPaging="false"
              :showHeader="false">
        <tr v-for="obj in this.stoppageHistory" v-bind:key="obj.id">
          <TableColumn :IsText="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.inicioParalisacao" />
          <TableColumn :IsText="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.terminoParalisacao" />
          <TableColumn :IsText="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.observacao" />
        </tr>
      </Tables>
    </b-modal>

    <!-- Formulário bonificação -->
    <b-modal
      v-model="showFormBonus"
      title="Formulário de Bonificação"
      size="xl"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      centered
    >
      <div v-if="showFormBonus" class="d-flex flex-column justify-content-start">
        <b-row class="formularioAvaliacaoTitulo">
          <b-col cols="3"><span>Contrato</span></b-col>
          <b-col cols="1" class="pl-0"><span>Obra</span></b-col>
          <b-col cols="2" class="pl-0"><span>ID Site</span></b-col>
          <b-col cols="1" class="pl-0"></b-col>
          <b-col cols="1" class="pl-0"><span>Início</span></b-col>
          <b-col cols="1" class="pl-0"><span>Término</span></b-col>
          <b-col cols="1" class="pl-0"><span>Prazo</span></b-col>
          <b-col cols="1" class="pl-0"><span>Paralisações</span></b-col>
          <b-col cols="1" class="pl-0"><span>Prazo Real</span></b-col>
        </b-row>
        <b-row>
          <b-col cols="3"><b-form-input type="text" class="p-2" disabled v-model="formCheckListBonus.contrato" /></b-col>
          <b-col cols="1" class="pl-0"><b-form-input type="text" class="p-2" disabled v-model="formCheckListBonus.obra" /></b-col>
          <b-col cols="2" class="pl-0"><b-form-input type="text" class="p-2" disabled v-model="formCheckListBonus.idSite" /></b-col>
          <b-col cols="1" class="pl-0"></b-col>
          <b-col cols="1" class="pl-0"><b-form-input type="text" class="p-2" disabled v-model="formCheckListBonus.inicioObra" /></b-col>
          <b-col cols="1" class="pl-0"><b-form-input type="text" class="p-2" disabled v-model="formCheckListBonus.terminoObra" /></b-col>
          <b-col cols="1" class="pl-0"><b-form-input type="number" class="p-2" disabled v-model="formCheckListBonus.prazoObra" /></b-col>
          <b-col cols="1" class="pl-0"><b-form-input type="number" class="p-2" disabled v-model="formCheckListBonus.paralisacoes" /></b-col>
          <b-col cols="1" class="pl-0"><b-form-input type="number" class="p-2" disabled v-model="realTerm" /></b-col>
        </b-row>
        <hr/>
        <b-row class="formularioAvaliacaoTitulo">
          <b-col cols="2"><span>Tipo</span></b-col>
          <b-col cols="2" class="pl-0"><span>Valor</span> </b-col>
          <b-col cols="1"><span>Lib.Avaliação</span></b-col>
          <b-col cols="1"><span>Prazo PDR</span></b-col>
          <b-col cols="1"></b-col>
          <b-col cols="5">
            <b-row>
              <b-col cols="3" class="pl-0"><span>AT antes term.obra</span> </b-col>
              <b-col cols="3" class="pl-0"><span>Doc.compl.term.</span> </b-col>
              <b-col cols="3" class="pl-0"><span>PO</span> </b-col>
              <b-col cols="3" class="pl-0"><span>FAT.%</span> </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2"><span><b-form-input type="text" v-model="formCheckListBonus.tipoBonificacao" /></span></b-col>
          <b-col cols="2" class="pl-0">
            <span><b-form-input id="fatValor" type="text" v-model="formCheckListBonus.valor" class="text-right" /></span>
            <span class="pequeno">PCI: {{ formCheckListBonus.valorCalculado }}</span>
          </b-col>
          <b-col cols="1"><span><b-form-input type="text" class="p-2" disabled v-model="formCheckListBonus.libAvaliacao" /></span></b-col>
          <b-col cols="1">
            <span>
              <b-form-input
                type="text"
                :class="{'text-prazopdr-vencido' : formCheckListBonus.prazoPdr > 45}"
                disabled
                :value="formCheckListBonus.prazoPdr" />
            </span>
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="5">
            <b-row>
              <b-col cols="3" class="pl-0"><b-form-select v-model="formCheckListBonus.checkAtAntesTermObra" :options="[{value:null, text:'Selecione'}, 'OK ', 'NOK']" /></b-col>
              <b-col cols="3" class="pl-0"><b-form-select v-model="formCheckListBonus.checkDocComplTerm" :options="[{value:null, text:'Selecione'}, 'OK ', 'NOK']" /></b-col>
              <b-col cols="3" class="pl-0"><b-form-select v-model="formCheckListBonus.checkPo" :options="[{value:null, text:'Selecione'}, 'OK ', 'NOK']" /></b-col>
              <b-col cols="3" class="pl-0"><b-form-input type="number" v-model="formCheckListBonus.percFat" /></b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr/>
        <div class="d-flex flex-row formularioAvaliacaoTitulo">
          <div style="width: 4rem;"><span class="d-flex justify-content-center">Ocultar</span><hr></div>
          <div style="width: 4rem;"><span class="d-flex justify-content-center">Liber.</span><hr></div>
          <div style="width: 4rem;"><span class="d-flex justify-content-center">Pago</span><hr></div>
          <div style="width: 15rem;" class="ml-1"><span>Membro</span><hr></div>
          <div style="width: 10rem;" class="ml-1"><span>Função</span><hr></div>
          <div style="width: 10rem;" class="ml-1"><span>Sit. RH</span><hr></div>
          <div style="width: 5rem;" class="ml-1"><span>Nota</span><hr></div>
          <div style="width: 8rem;" class="ml-1"><span>Bruto</span><hr></div>
          <div style="width: 4rem;" class="ml-1"><span>% (+)</span><hr></div>
          <div style="width: 4rem;" class="ml-1"><span>% (-)</span><hr></div>
          <div style="width: 4rem;" class="ml-1"><span>% (-)</span><hr></div>
          <div style="width: 10rem;" class="ml-1"><span>Débitos (saldo)</span><hr></div>
          <div style="width: 10rem;" class="ml-1"><span>Desconto</span><hr></div>
          <div style="width: 10rem;" class="ml-1"><span>Liquido</span><hr></div>
          <div class="flex-grow-1 ml-1"><span>Observações</span><hr></div>
        </div>
        <div class="d-flex flex-row" v-for="membro in formCheckListBonus.membros" :key="membro.obraMembroID">
          <div style="width: 4rem;" class="d-flex justify-content-center align-items-start">
            <b-checkbox
              class="pl5"
              name="cbxAction"
              v-model="membro.ocultar"
              :disabled="membro.pdrPago"
            />
          </div>
          <div style="width: 4rem;" class="d-flex justify-content-center align-items-start">
            <b-checkbox
              class="pl5"
              name="cbxReleased"
              v-model="membro.pdrLiberado"
              :disabled="membro.pdrPago"
            />
          </div>
          <div style="width: 4rem;" class="d-flex justify-content-center align-items-start">
            <b-checkbox
              type="checkbox"
              class="pl5"
              name="cbxPaid"
              v-model="membro.pdrPago"
              disabled
            />
          </div>
          <div style="width: 15rem;" class="ml-1 d-flex align-items-center" :class="{'member-duplicated': membro.duplicado}">
            <p class="text-cols-form-bonif" style="text-transform: capitalize;">{{membro.nome.toLowerCase()}}</p>
          </div>
          <div style="width: 10rem;" class="ml-1 d-flex align-items-center">
            <p class="text-cols-form-bonif">{{membro.funcao.toLowerCase()}}</p>
          </div>
          <div style="width: 10rem;" class="ml-1 d-flex align-items-center">
            <p class="text-cols-form-bonif">{{membro.situacaoRh}}</p>
          </div>
          <div style="width: 5rem;" class="ml-1">
            <b-form-input type="number"
                          disabled
                          :value="membro.nota"
                          :class="{'text-nota-baixa' : membro.nota < 5.9}"/>
          </div>
          <div style="width: 8rem;" class="ml-1">
            <b-form-input type="number"
                          :no-wheel="true"
                          @keydown.down.prevent
                          @keydown.up.prevent
                          @keydown.enter.native="sendBonusFormPartial"
                          v-model="membro.valorBruto"
                          :disabled="membro.pdrPago" />
          </div>
          <div style="width: 4rem;" class="ml-1">
            <b-form-input type="number"
                          :no-wheel="true"
                          @keydown.down.prevent
                          @keydown.up.prevent
                          @keydown.enter.native="sendBonusFormPartial"
                          v-model="membro.adicional"
                          :disabled="membro.pdrPago" />
          </div>
          <div style="width: 4rem;" class="ml-1">
            <b-form-input type="number"
                          :no-wheel="true"
                          @keydown.down.prevent
                          @keydown.up.prevent
                          @keydown.enter.native="sendBonusFormPartial"
                          v-model="membro.reducao1"
                          :disabled="membro.pdrPago" />
          </div>
          <div style="width: 4rem;" class="ml-1">
            <b-form-input type="number"
                          :no-wheel="true"
                          @keydown.down.prevent
                          @keydown.up.prevent
                          @keydown.enter.native="sendBonusFormPartial"
                          v-model="membro.reducao2"
                          :disabled="membro.pdrPago" />
          </div>
          <div style="width: 10rem;" class="ml-1">
            <b-form-input type="number"
                          disabled
                          :style="{color: membro.saldoDebitos ? 'red' : '', fontWeight: membro.saldoDebitos ? 'bold' : 'normal'}"
                          v-model="membro.saldoDebitos" />
          </div>
          <div style="width: 10rem;" class="ml-1">
            <b-form-input type="number"
                          :no-wheel="true"
                          :disabled="membro.pdrPago || membro.valorZerado || !membro.saldoDebitos"
                          @keydown.down.prevent
                          @keydown.up.prevent
                          @keydown.enter.native="sendBonusFormPartial"
                          v-model="membro.desconto" />
          </div>
          <div style="width: 10rem;" class="ml-1">
            <div class="d-flex align-items-center">
              <b-form-input type="number"
                            disabled
                            :value="evaluationLiquidValue(membro)" />
              <span @click="evaluationToggleLiquidValue(membro)" style="cursor:pointer;" class="ml-1">
                <i class="fas fa-backspace"
                   v-if="!membro.pdrPago && !membro.valorZerado"
                   v-b-tooltip.hover :title="'Clique para zerar o valor'">
                </i>
                <i class="fas fa-redo-alt"
                   v-if="!membro.pdrPago && membro.valorZerado"
                   v-b-tooltip.hover :title="'Clique para restaurar o valor'">
                </i>
              </span>
            </div>
          </div>
          <div class="flex-grow-1 mb-1 ml-1">
            <b-form-textarea v-model="membro.observacoes" :max-rows="8" :rows="2" :disabled="membro.pdrPago"></b-form-textarea>
          </div>
        </div>
        <hr/>
        <b-row class="formularioAvaliacaoTitulo">
          <b-col cols="12"><span>Observações</span></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-textarea v-model="formCheckListBonus.observacao"
                             :max-rows="20" :rows="2">
            </b-form-textarea>
          </b-col>
        </b-row>
        <hr/>
        <div id="div-buttons">
          <button type="button" class="btn btn-third btn-sm" :disabled="sendingBonus" v-on:click="sendBonusFormPartial" v-b-tooltip.hover>
            <i class="fas fa-save"></i>&nbsp;&nbsp;Gravar
          </button>
          <button type="button" class="btn btn-third btn-sm" :disabled="sendingBonus" v-on:click="sendBonusForm" v-b-tooltip.hover>
            <i class="fa fa-check"></i>&nbsp;&nbsp;Finalizar
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Histórico de avaliação -->
    <b-modal
      v-model="showPdrLog"
      title="Histórico de avaliação"
      size="lg"
      :hide-footer="true"
      scrollable
    >
      <SimpleTableList :objList="logPdr"></SimpleTableList>
    </b-modal>

    <!-- Excluir Pdr -->
    <b-modal
      v-model="showExclusionPdr"
      :title="$lang.PCI.PDR.ExclusionPDR.TitleForm"
      size="lg"
      :hide-footer="true"
      scrollable
    >
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label for="txtDescription"><small class="text-danger">*</small> {{$lang.PCI.PDR.ExclusionPDR.LabelJustification}}</label>
          <b-form-textarea
            v-model="editExclusionObservation"
            style="height: 200px"
            :placeholder="$lang.PCI.PDR.ExclusionPDR.PlaceHolderJustification"></b-form-textarea>
        </div>
      </div>
      <div id="div-buttons" class="mt-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="exclusionPdr(true)" v-b-tooltip.hover><i class="fa fa-check"></i> {{$lang.Common.Buttons.Confirm}}</button>
        <button type="button" class="btn btn-danger btn-sm" v-on:click="exclusionPdr(false)" v-b-tooltip.hover><i class="fa fa-ban"></i> {{$lang.Common.Buttons.Cancel}}</button>
      </div>
    </b-modal>

    <!-- Arquivar Pdr -->
    <b-modal
      v-model="showArchivePdr"
      :title="$lang.PCI.PDR.ArchivePDR.TitleForm"
      size="lg"
      :hide-footer="true"
      scrollable
    >
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label for="txtDescription"><small class="text-danger">*</small> {{$lang.PCI.PDR.ArchivePDR.LabelJustification}}</label>
          <b-form-textarea
            v-model="editArchiveObservation"
            style="height: 200px"
            :placeholder="$lang.PCI.PDR.ArchivePDR.PlaceHolderJustification"></b-form-textarea>
        </div>
      </div>
      <div id="div-buttons" class="mt-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="archivePdr(true)" v-b-tooltip.hover><i class="fa fa-check"></i> {{$lang.Common.Buttons.Confirm}}</button>
        <button type="button" class="btn btn-danger btn-sm" v-on:click="archivePdr(false)" v-b-tooltip.hover><i class="fa fa-ban"></i> {{$lang.Common.Buttons.Cancel}}</button>
      </div>
    </b-modal>

    <!-- modal_avaliação -->
    <b-modal
      id="evaluationModal"
      ref="evaluationModal"
      v-model="showModalEvaluation"
      v-if="showModalEvaluation"
      size="xl"
      :no-close-on-esc="true"
      :hide-footer="true"
      @shown="onShowEvaluationModal"
      @hide="postEditFactor"
      centered
    >
      <template #modal-header>
        <div class="d-flex align-items-center col-12">
          <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
          <span class="modalTitle ml-auto">
            Avaliação
          </span>
          <button class="close" @click="$refs['evaluationModal'].hide()">x</button>
        </div>
      </template>
      <div v-if="showModalEvaluation" class="d-flex flex-column justify-content-start">
        <div class="d-flex flex-wrap justify-content-around align-items-center" v-if="selectedMember">
          <div class="d-flex flex-column px-4">
            <span>Obra (Código)</span>
            <b>{{ this.selectedMember.referenciaObra }}</b>
          </div>
          <div class="d-flex flex-column px-4">
            <span>ID Site (Obra)</span>
            <b>{{ this.selectedMember.codigoObra }}</b>
          </div>
          <div class="d-flex flex-column px-4">
            <span>Tipo (Obra)</span>
            <b>{{ this.selectedMember.tipoObra }}</b>
          </div>
          <div class="d-flex flex-column px-4">
            <span>Função</span>
            <b>{{ this.selectedMember.funcaoObra.nome }}</b>
          </div>
          <div class="d-flex flex-column px-4">
            <span>Funcionário</span>
            <b>{{ this.selectedMember.nome }}</b>
          </div>
          <div class="d-flex flex-column px-4">
            <span>Início</span>
            <b>{{ this.selectedMember.inicioAtividades ? new Date(this.selectedMember.inicioAtividades).toLocaleDateString() : '' }}</b>
          </div>
          <div class="d-flex flex-column px-4">
            <span>Término</span>
            <b>{{ this.selectedMember.terminoAtividades ? new Date(this.selectedMember.terminoAtividades).toLocaleDateString() : '' }}</b>
          </div>
          <div class="d-flex flex-column px-4">
            <span>Dias</span>
            <b>{{ this.selectedMember.diasCorridos }}</b>
          </div>
          <div class="d-flex flex-column px-4">
            <span>Paral.</span>
            <b>{{ this.selectedMember.diasParalisado }}</b>
          </div>
          <div class="d-flex flex-column px-4">
            <span>Prazo</span>
            <b>{{ this.selectedMember.prazo }}</b>
          </div>
        </div>

        <div id="div-cabecalhoItem" class="d-flex">
          <div style="width: 100%;" class="d-flex align-items-center">
            <b-col cols="8" style="height: 80%;">
              <img id="imgDetalhes" :src="itemImage" class="h-100" />
            </b-col>
            <b-col cols="4">
              <span id="observacao">{{ itemObservation }}</span>
            </b-col>
          </div>
          <b-row v-if="!selectedItemForm">
            <span id="orientacao">Selecione um item para exibir os detalhes</span>
          </b-row>
        </div>

        <div id="gridAvaliacao">
          <ag-grid-vue id="grid-itens-formulario"
                  style="width:100%;height:calc(100vh - 520px);"
                  class="ag-theme-alpine gridAvaliacao"
                  groupDisplayType="singleColumn"
                  :getLocaleText="localeTextFunc"
                  :gridOptions="itemsEvaluationDataGridOptions"
                  :columnTypes="columnTypes"
                  :columnDefs="formItems.grid.Headers"
                  :defaultColDef="defaultColumnDef"
                  :rowData="formItems.grid.Data"
                  :headerHeight="30"
                  :rowHeight="30"
                  :getRowId="params => params.data.id"
                  :stopEditingWhenCellsLoseFocus="true"
                  @cellFocused="selectItemEvaluationForm"
                  @cellValueChanged="onEditFator"
                  @firstDataRendered="onGridItemsFormReady"
                  @cell-editing-started="evaluationEditing = true"
                  @cell-editing-stopped="onStopEditFactor"
                  :processDataFromClipboard="processDataFromClipboard"
                  :autoGroupColumnDef="autoGroupColumnDef"
                  :suppressLastEmptyLineOnPaste="true"
                  >
                  <!-- :navigateToNextCell="navigateToNextCell" -->
                  <!-- rowSelection="single" -->
          </ag-grid-vue>

        </div>
        <div id="div-buttons" v-if="selectedMember == null">
          <button type="button" class="btn btn-third btn-sm" v-on:click="enviarNotaLote(false)" v-b-tooltip.hover><i class="fa fa-check"></i> Aplicar nos membros</button>&nbsp;
          <button type="button" class="btn btn-warning btn-sm" v-on:click="enviarNotaLote(true)" v-b-tooltip.hover><i class="fa fa-check-double"></i> Aplicar nos Contratos</button>&nbsp;
        </div>
      </div>
    </b-modal>
    <!-- modal_avaliação -->

    <cop ref="cop" v-if="showCopOf" @hide="onHideCop" @showTeam="onViewTeam" :readOnly="true" />
    <construction-team ref="team" v-if="showConstructionTeam" @close="showConstructionTeam = false" />
  </div>
</template>

<script>
import PDR from './pdr.js'
export default PDR
</script>

<style scoped>
  * >>> .floatType, * >>> .integerType {
    text-align: right;
  }
  .formularioAvaliacaoTitulo span {
    font-weight: bold;
  }

  .member-duplicated {
    color: red;
    font-weight: bolder;
    background-color: lightyellow;
  }

  .pequeno {
    font-size: 10px;
  }

  hr {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }

  p.function {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  #tabEquipe {
    width: 100%;
    margin: 0px 5px 0px 5px;
  }

  #imgDetalhes {
    display:block;
    margin:auto;
    max-width: 700px;
  }

  #orientacao {
    display:block;
    margin:auto;
    font-size: 15px;
    font-weight: bold;
  }

  #gridAvaliacao {
    width: 100%;
    height: 100%;
  }

  .gridAvaliacao {
    margin-bottom: 10px;
    height: 100%;
  }

  * >>> .ag-row-level-0 .ag-cell-wrapper {
    align-items: center !important;
  }
  * >>> .ag-row-level-0 .ag-cell-wrapper .ag-group-child-count {
    display: none !important;
  }
  * >>> .ag-row-level-1 .ag-cell-wrapper span {
    border: none !important;
  }

  #div-cabecalhoItem {
    height: 250px;
    padding: 15px;
    border: 2px solid #006100;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  #div-buttons {
    text-align: right;
  }

  #observacao {
    font-weight: bold;
  }

  * >>> #evaluationModal .modal-content {
    height: calc(100vh - 100px);
  }

  .copImg {
    height: 400px;
    width: 100%;
    display: block;
    margin-top: 20px;
  }

  * >>> #copOf .col:first-of-type {
    padding: 0 !important;
  }

  * >>> #copOf .modal-content,
  * >>> #copPdf .modal-content,
  * >>> #copImg .modal-content {
    min-height: 550px;
  }

  * >>> #copImg .modal-dialog {
    margin: 30px 4.5vw !important;
  }

  * >>> #copImg .modal-dialog {
    padding-bottom: 40px !important;
  }

  * >>> #copImg .modal-content {
    width: 90vw !important;
  }

  * >>> #copOf .modal-dialog,
  * >>> #copPdf .modal-dialog {
    margin: 30px auto !important;
    max-width: 1305px !important;
  }

  * >>> #copOf .modal-content,
  * >>> #copPdf .modal-content {
    width: 99vw !important;
    max-width: 1305px;
  }

  * >>> #copOf .modal-body {
    padding: 0;
  }

  * >>> #copOf .tab-content .tab-pane {
    padding: 0.5rem;
  }

  * >>> #copPdf .modal-content,
  * >>> #copImg .modal-content {
    height: 90vh !important;
  }

  .cop-grid {
    width: 100%;
    height: calc(99vh - 310px);
  }

  * >>> .cop-grid * {
    font-size: 0.66rem !important;
    text-align: center !important;
  }

  * >>> .cop-grid div[col-id="description"] {
    font-size: 0.66rem !important;
    text-align: left !important;
  }

  * >>> .cop-grid .ag-cell,
  * >>> .cop-grid .ag-header-cell {
    padding-left: 3px !important;
    padding-right: 3px !important;
  }

  * >>> #copOf .ag-center-cols-viewport {
    overflow-x: hidden !important;
  }

  .modalTitle {
    text-transform: uppercase;
    font-size: 1.5rem;
    color: yellow;
  }
  * >>> .modal-header {
    padding: 1em;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
  }
  * >>> .modal-body {
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    scroll-snap-type: y proximity;
  }
  * >>> .modal-footer {
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
  }
  * >>> .modal-content {
    border-radius: 25px;
  }

  * >>> .modal footer button:first-of-type:hover {
    color: #ffffff !important;
    background: #4285f4 !important;
  }

  * >>> .nav-link, .navbar .dropdown-toggle {
    padding: .5rem .5rem;
  }

  input.text-nota-baixa {
    color: red;
    background-color: #ffdddd;
    font-weight: bold;
  }

  .text-cols-form-bonif {
    font-size: 13px;
  }

  input.text-prazopdr-vencido {
    background-color: yellow;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/pdr/pdr.vue